import {Component, NgZone, OnInit} from "@angular/core";
import {EvaButton} from "../../../shared/eva-button/eva-button";
import {ActivatedRoute, Router} from "@angular/router";
import {LoadingWheelService} from "../../../root/loading/loading-wheel.service";
import {ModalService} from "../../../root/modal/modal.service";
import {PickupPointFeeService} from "../pickup-point-fee.service";
import {PickupPointFee} from "../edit/pickup-point.fee";
import {PointOfSaleA2Service} from "../../../core/point-of-sale.service.service";
import {Observable} from "rxjs/Observable";
import {AdditionalPickupPointService} from "../../../core/additional-pickup-point.service";
import {SessionService} from "../../../core/session.service";
import {Page} from "../../../shared/pager/page";
import {SidebarService} from "../../../root/sidebar/sidebar.service";

@Component({
    selector: 'pickup-point-fee-list',
    templateUrl: './pickup-point-fee-list.component.html',
    providers: [PickupPointFeeService, PointOfSaleA2Service, AdditionalPickupPointService]
})
export class PickupPointFeeListComponent implements OnInit {

    newButton:EvaButton = new EvaButton('common.NEW', '-primary', '-md');
    companyId:number;
    list:PickupPointFee[];
    pickupsMap:any;
    page:Page;

    constructor(private modalService:ModalService, private loading:LoadingWheelService,
                private pupFeeService:PickupPointFeeService, private route: Router, private activatedRoute: ActivatedRoute,
                private posService: PointOfSaleA2Service, private session:SessionService,
                private addPointService: AdditionalPickupPointService, private  zone: NgZone, private sidebar: SidebarService) {
        this.sidebar.sidebar = "generalConditions";
    }

    add(){
        this.route.navigateByUrl('/company/'+this.companyId+'/pickupPointFee/add');
    }

    throwError(){
        throw ("..."    );
    }

    edit(id:string){
        this.route.navigateByUrl('/company/'+this.companyId+'/pickupPointFee/' + id);
    }

    private removeCallback(context:any){
        context.toast.displayToast('fees.TITLE','common.confirmationMessage.SUCCESS_DELETE', null, 'INFO');
        this.ngOnInit();
    }

    remove(id:string){
        let context = this;
        this.modalService.show("REMOVE_ALERT_TITLE", "REMOVE_ALERT_DESCRIPTION", () => {
            this.pupFeeService.remove(this.companyId, id).subscribe(() => {
                context.removeCallback(context)
            });
        });
    }

    isEditable(){
        return this.session.loggedUserAllowed('PERM_FEE_EDIT');
    };

    isRemovable(){
        return this.session.loggedUserAllowed('PERM_FEE_DELETE');
    };

    canCreate(){
        return this.session.loggedUserAllowed('PERM_FEE_CREATE');
    };

    isLoading(){
        return this.loading.isLoading();
    }

    ngOnInit() {
        let context = this;
        let pos = [];
        let adds = [];
        context.loading.show();
        this.pickupsMap = {};
        this.activatedRoute.params.subscribe(params => {
            this.companyId = params['id'];
            this.zone.run(() => {
                Observable.forkJoin([
                        this.posService.get(this.companyId), 
                        this.addPointService.get(this.companyId),
                        this.pupFeeService.get(this.companyId)
                    ]).subscribe(result => {
                        pos = result[0];
                        adds = result[1];
                        context.list = <PickupPointFee[]> result[2];
                        this.page = new Page(10,1,context.list.length, context.list);
                        context.loading.hide();
                        if(!context.list || context.list.length == 0){
                            context.route.navigateByUrl('/company/'+context.companyId+'/pickupPointFee/add');
                        }
                        context.pupFeeService.buildPickupsMap(pos, adds, context);
                })
            })
        });
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/pickuppointfee/list/pickup-point-fee-list.component.ts